"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReturnsByScanCenter = void 0;
var get_returns_by_scan_center_1 = require("./get-returns-by-scan-center");
Object.defineProperty(exports, "getReturnsByScanCenter", { enumerable: true, get: function () { return get_returns_by_scan_center_1.getReturnsByScanCenter; } });
//# sourceMappingURL=index.js.map